import { render, staticRenderFns } from "./CavendishExperimentViz.vue?vue&type=template&id=54f71bc2&scoped=true"
import script from "./CavendishExperimentViz.vue?vue&type=script&lang=js"
export * from "./CavendishExperimentViz.vue?vue&type=script&lang=js"
import style0 from "./CavendishExperimentViz.vue?vue&type=style&index=0&id=54f71bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f71bc2",
  null
  
)

export default component.exports